import 'uni-pages';import 'uni-h5';import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "./store";
import App from "./App";
import "@/js_sdk/WebViewJavascriptBridge.js";
import NavBar from "@/components/NavBar.vue";
import UniIcons from "@/components/uni-icons/uni-icons.vue";
import * as Sentry from "@sentry/vue";
import messages from "./locale";

Vue.use(VueI18n);
const msg = (title, duration = 1500, mask = false, icon = "none") => {
  //统一提示方便全局修改
  if (Boolean(title) === false) {
    return;
  }
  uni.showToast({
    title,
    duration,
    mask,
    icon,
  });
};

const prePage = () => {
  let pages = getCurrentPages();
  let prePage = pages[pages.length - 2];

  return prePage;

  return prePage.$vm;
};

Vue.config.productionTip = false;
Vue.prototype.$fire = new Vue();
Vue.prototype.$store = store;
Vue.prototype.$api = { msg, prePage };
Vue.component("NavBar", NavBar);
Vue.component("UniIcons", UniIcons);

App.mpType = "app";
const app = new Vue({
	i18n: new VueI18n({
    locale: "en",
    messages,
  }),
  ...App,
});
Sentry.init({
  Vue,
  dsn: "https://f2a1eb787e7f21e9967b63266a01c798@analysis.blurams.com/6",
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
});
app.$mount();